import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/about/page.tsx");
